import { getGraphqlApiBaseUrl } from "../config";
import type { StatusEventPayload } from "./documentExtractionJobs";
import { normalizeStreamStatus } from "./documentExtractionJobs";

export function parseEventBlocks(buffer: string): { events: string[]; rest: string } {
  const parts = buffer.split("\n\n");
  const rest = parts.pop() ?? "";
  return { events: parts, rest };
}

export function parseSseEvent(block: string): { event: string; data: string } | null {
  let event = "message";
  const dataLines: string[] = [];
  for (const line of block.split("\n")) {
    if (line.startsWith("event:")) event = line.slice(6).trim();
    if (line.startsWith("data:")) dataLines.push(line.slice(5).trim());
  }
  if (dataLines.length === 0) return null;
  return { event, data: dataLines.join("\n") };
}

export function getTenantStatusStreamUrl(documentIds?: string[]): string {
  const base = `${getGraphqlApiBaseUrl()}/documents/status/stream`;
  if (!documentIds || documentIds.length === 0) return base;
  const params = new URLSearchParams();
  params.set("documentIds", documentIds.join(","));
  return `${base}?${params.toString()}`;
}

export function parseDocumentStatusPayload(data: string): StatusEventPayload | null {
  try {
    const payload = JSON.parse(data) as {
      documentId: string;
      status: string;
      error?: string | null;
      processed_at?: string | null;
      progress?: number | null;
      stage?: string | null;
    };
    if (!payload.documentId || !payload.status) return null;
    return {
      documentId: payload.documentId,
      status: normalizeStreamStatus(String(payload.status)),
      error: payload.error ?? null,
      processed_at: payload.processed_at ?? null,
      progress: payload.progress ?? undefined,
      stage: payload.stage ?? null,
    };
  } catch {
    return null;
  }
}
